export default __webpack_public_path__ + "static/media/img2.1ccf70e0.jpg";